import React, { Component } from "react";
import styled from "styled-components";

/* We take 100% width, 100% height of what's offered; our parent constraints our size */
const ToolbarDiv = styled.div`
    background-color:var(--panel-bg-colour);
    padding: 5px;
    width:100%;
    height:100%;
    display:flex;
    flex-wrap: wrap;
    flex-direction:${props => props.layout === "horizontal" ? "row" : "column"};
    align-items: center;
    justify-content: center
`;

class Toolbar extends Component {
    render() {
        return (
            <ToolbarDiv
                layout={this.props.viewMode === "chat" ? "vertical" : "horizontal"}
            >
                {this.props.children}
            </ToolbarDiv>
        );
    }
}

export default Toolbar;